import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Typography, styled } from "@mui/material"

import List from "components/ui/InfoList"
import Title from "components/ui/ModalTitle"
import { formatMoney } from "helpers/formatters"
import { DebtType } from "types"

type Props = {
  amount: number
  debt: DebtType
}

const NewPayment = ({ amount, debt }: Props) => {
  const { t } = useTranslation()

  // TODO: fetch from api
  const items = [
    {
      label: t("features.payment.transfer.list.beneficiary.name"),
      value: debt?.company?.legal_name,
    },
    {
      label: t("features.payment.transfer.list.beneficiary.account"),
      value: debt?.company?.primary_bank_account_number,
    },
    {
      label: t("features.payment.transfer.list.description.title"),
      value: debt.reference_number,
    },
    {
      label: t("features.payment.transfer.list.reference.number"),
      value: debt.reference_number,
    },
  ]

  return (
    <Container>
      <Title>{t("features.payment.form.title")}</Title>
      <Wrapper>
        <Amount variant="h1">{formatMoney(amount)}</Amount>
        <List items={items} />
      </Wrapper>
    </Container>
  )
}

export default NewPayment

const Container = styled(Box)(({ theme }) => ({
  marginTop: "40px",
  [theme.breakpoints.down("lg")]: {
    margin: "0",
  },
}))

const Wrapper = styled(Box)(() => ({
  margin: "11px 0 35px 0",
}))

const Amount = styled(Typography)(() => ({
  fontSize: "3.5rem",
  fontWeight: 400,
  height: "1.4375em",
  lineHeight: "1.4375em",
  margin: "0 0 34px 0",
  padding: 0,
  textAlign: "center",
}))
